import { ModalSelectDate } from "./modalSelectDate.js";
import { ModalTiteledWindow } from "./modalWindow.js";
import { RadioButtons } from "../radiobuttons.js";
import { sortObjectArray } from "../util.js";
import { groupData } from "../util.js";
import { ModalShowAbsentItemDetails } from "./modalShowAbsentItemDetails.js";

export class ModalShowAbsentItemsOfClass extends ModalTiteledWindow {

   constructor(type, title, app, cls) {
      super();
      this.app = app;
      this.type = type;
      this.class = cls;
      this.addClass('modal-show-absences');
      this.setTitle(`${this.class.name}: ${title}`);

      this.setBody(`
         <div class="select"><span class="help icon-info" selector=".modal-absent-homework" style="position: absolute; right: 0.5rem;"></span>
            <div class="date-range">
               <div class="range">
                  von 
                  <div class="date date-from" date="from"></div>
                  bis
                  <div class="date date-to" date="to"></div>
               </div>
            </div>
         </div>
         <div class="absences"></div>
      `);

      this.dateRange = new RadioButtons('date-range', {
            onSelect: (value) => this.setRangeType(value)
         },
         [
            { label: "Schuljahr", value: "full-year" },
            { label: "Zeitraum",  value: "date-range" },
         ]
      );
      this.panel.querySelector('.select .date-range').prepend(this.dateRange.getElement());

      this.elDateFrom = this.panel.querySelector('.date-range .date-from');
      this.elDateTo = this.panel.querySelector('.date-range .date-to');

      [this.elDateFrom, this.elDateTo].forEach(el => el.onclick = (event) => {
         const elDate = event.currentTarget;
         new ModalSelectDate({ onSelect: (value) => {
            elDate.dataset.date = value.isoDate();
            elDate.innerText = value.toGermanDate();
            localStorage.setItem('absenceDatesRange', JSON.stringify({ from: this.elDateFrom.dataset.date, to: this.elDateTo.dataset.date }));
            this.loadData();
         }});
      });

      this.dateRange.setValue('full-year', true);
      
      this.setupHelp(this.app);

      setTimeout(() => this.show(), 1);

   }

   setRangeType(type) {

      this.sortKeys = [];

      if (type === 'full-year') {
         this.panel.querySelector('.date-range .range').style.display = 'none';
      }
      else {

         let range;
         try {
            range = JSON.parse(localStorage.getItem('absenceDatesRange'));
            if (!range) throw new Error();
         }
         catch(e)  { range = { from: (new Date()).isoDate(), to: (new Date()).isoDate() }; }

         this.panel.querySelector('.date-range .range').style.display = 'flex';

         this.elDateFrom.dataset.date = range.from;
         this.elDateFrom.innerText = Date.fromString(range.from).toGermanDate();
         this.elDateTo.dataset.date = range.to;
         this.elDateTo.innerText = Date.fromString(range.to).toGermanDate();
      }

      this.loadData();

   }

   async loadData() {

      if (this.dateRange.getValue() !== 'full-year') {
         const data = await this.app.dm.sinRequest({
            action: 'classreg-absent-items-get',
            type: this.type,
            classId: this.class.id,
            dateFrom: this.elDateFrom.dataset.date,
            dateTo: this.elDateTo.dataset.date
         });
         this.data = data.data;
      }
      else {
         const year = this.app.dm.getCurrentYear();
         const data = await this.app.dm.sinRequest({
            action:   'classreg-absent-items-get',
            type: this.type,
            classId:  this.class.id,
            dateFrom: year.dateFrom,
            dateTo:   year.dateTo
         });
         this.data = data.data;
      }

      this.updateAbsences();

   }

   updateAbsences() {

      if (!this.sortKeys.includes('<.normedLastName')) this.sortKeys.push('<.normedLastName');

      if (this.dateRange.getValue() === 'full-year') {

         const year = this.app.dm.getCurrentYear();
         let data = groupData(this.data, ['pupilId'],
            (group) => { group.hj1 = 0; group.hj2 = 0, group.sum = 0 },
            (group, item) => {
               if      (item.date >= year.dateFrom && item.date < year.dateHj2) group.hj1 += item.value;
               else if (item.date >= year.dateHj2  && item.date < year.dateTo)  group.hj2 += item.value;
               group.sum += item.value;
            }
         );

         let pupils = this.applyAbsencesToPupils(data);
         sortObjectArray(pupils, this.sortKeys);

         let html = `<table class="bl-2 br-2 bt-2 bb-2">
         <thead>
            <tr>
               <th class="ta-left" data-sort-key="<.normedLastName">Nachname</th>
               <th class="ta-left" data-sort-key="<.normedFirstName">Vorname</th>
               <th class="bl-2" data-sort-key=">.absences.hj1">1. HJ</th>
               <th class="br-2" data-sort-key=">.absences.hj2">2. HJ</th>
               <th class="br-2" data-sort-key=">.absences.sum">∑</th>
            </tr>
         </thead><tbody>`;

         let sum = 0;
         for (let pupil of pupils) {
            html += `<tr data-pupil-id="${pupil.id}"><td>${pupil.lastName}</td><td>${pupil.firstName}</td>
            <td class="number bl-2">${pupil.absences.hj1}</td><td class="number">${pupil.absences.hj2}</td><td class="number sum bl-2">${pupil.absences.sum}</td></tr>`;
            sum += pupil.absences.sum;
         }

         html += `<tr><td colspan="4" class="fw-bold bt-2">gesamt</td><td class="number sum bt-2 bl-2">${sum}</td></tr></tbody></table>`;
         this.panel.querySelector('.absences').innerHTML = html;

      }
      else {

         let data = groupData(this.data, ['pupilId'],
            (group) => { group.sum = 0; },
            (group, item) => { group.sum += item.value; }
         );

         let pupils = this.applyAbsencesToPupils(data);
         sortObjectArray(pupils, this.sortKeys);

         let html = `<table class="bl-2 br-2 bt-2 bb-2">
         <thead>
            <tr>
               <th class="ta-left" data-sort-key="<.normedLastName">Nachname</th>
               <th class="ta-left" data-sort-key="<.normedFirstName">Vorname</th>
               <th class="bl-2 br-2" data-sort-key=">.absences.sum">∑</th>
            </tr>
         </thead><tbody>`;

         let sum = 0;
         for (let pupil of pupils) {
            html += `<tr data-pupil-id="${pupil.id}"><td>${pupil.lastName}</td><td>${pupil.firstName}</td>
            <td class="number sum br-2 bl-2">${pupil.absences.sum}</td></tr>`;
            sum += pupil.absences.sum;
         }

         html += `<tr><td colspan="2" class="fw-bold bt-2">gesamt</td><td class="number sum br-2 bl-2 bt-2">${sum}</td></tr></tbody></table>`;

         this.panel.querySelector('.absences').innerHTML = html;

      }

      this.panel.querySelectorAll('th').forEach(elTh => {
         const indexColor = [ .5, .3, .2 ];
         for (let i=0; i<this.sortKeys.length; ++i) {
            if (elTh.dataset.sortKey === this.sortKeys[i]) {
               elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[i]})`;
            }
         }
      });

      this.panel.querySelectorAll('.absences th').forEach(elTh => {
         let sortKey = elTh.dataset.sortKey;
         if (sortKey) {
            elTh.onclick = () => this.collectSortKey(elTh, sortKey);
         }
      });

      this.panel.querySelectorAll('.absences tbody td').forEach(elTd => elTd.onclick = (event) => {
         let pupilId = event.currentTarget.parentNode.dataset.pupilId;
         if (pupilId) this.showDetails(parseInt(pupilId));
      });

   }

   applyAbsencesToPupils(absences) {

      let pupils = this.class.pupils.map(pupilId => {
         let pupil = this.app.dm.getUser(pupilId);
         const abs = absences.find(item => item.pupilId === pupil.id);
         if (abs) {
            pupil.absences = abs;
         }
         else pupil.absences = { hj1: 0, hj2: 0, sum: 0 };
         return pupil;
      });      

      return pupils;

   }


   showDetails(pupilId) {

      const data = this.data.filter(item => item.pupilId === pupilId);
      const pupil = this.app.dm.getUser(pupilId);
      new ModalShowAbsentItemDetails(this.app, "Versäumte Hausaufgaben", pupil, data);

   }

   collectSortKey(elTh, sortKey) {

      const indexColor = [ .5, .3, .2 ];

      if (!this.collectingSortKeys) {
         this.sortKeys = [ sortKey ];
         this.collectingSortKeys = true;
         setTimeout(() => {
            this.collectingSortKeys = false;
            this.updateAbsences();
         }, 1000);
         this.panel.querySelectorAll('th').forEach(elTh => elTh.style.removeProperty('background-color'));
         elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[0]})`;
      }
      else {
         if (!this.sortKeys.includes(sortKey) && this.sortKeys.length < 3) {
            this.sortKeys.push(sortKey);
            elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[this.sortKeys.length-1]})`;
         }
      }

   }

}
